import { render, staticRenderFns } from "./PortTextField.vue?vue&type=template&id=50437854&scoped=true"
import script from "./PortTextField.vue?vue&type=script&lang=js"
export * from "./PortTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50437854",
  null
  
)

export default component.exports